import type { ModuleKey } from "./modules";

export interface FeatureDefinition {
  label: string;
  module: ModuleKey;
  /** Granted regardless of plan (dashboard, settings, notification plumbing). */
  alwaysOn?: boolean;
  medicaidOnly?: boolean;
  description?: string;
  /** On wherever the named feature is on, unless an override names this key; otherwise following
   * the plan would leave it off where its product is switched on by override. A string because
   * `FeatureKey` would make the registry's type self-referential. */
  follows?: string;
  /** Off unless an override switches it on, for everybody (no plan, always-on list, planless
   * organization or platform administrator): for capabilities that send something outside the
   * building, where "on because nobody chose a plan" is no decision. */
  optIn?: boolean;
}

export const feature = (label: string, module: ModuleKey, extra: Partial<FeatureDefinition> = {}) =>
  ({ label, module, ...extra }) satisfies FeatureDefinition;
